<template>
  <div>
    <Banner />
    <section class="hero">
      <img src="@/assets/about/about-header@2x.png">
      <p class="mt-8 text-center">
        “广州盈声科技有限公司”（Positive Grid）总部位于加州，致力于设计和开发基础的核心技术，并专注于为音乐人提供硬件和软件上的超凡创造性体验。
      </p>
      <div>
        <h3>我们正在改变音乐制作的方式</h3>
        <p>音乐不仅仅是聆听 – 音乐还是创造、分享、发现、参与和连接。音乐是原始的社交网络，不仅能消除障碍、触及灵魂，还能将来自世界各地的人们聚集到一起。</p>
      </div>
    </section>
    <section class="cards">
      <div class="card">
        <img src="@/assets/about/p-1010283@2x.png">
        <div>
          <h3>一个全球性的音乐社区：</h3>
          <p>当我们在 2013 年开始起步时，Positive Grid 还只是一个小型的团队，既有一个有趣的名字又有一个远大的理想。通过领先的人工智能软件技术以及创新音色和界面设计的结合，我们让所有感兴趣的音乐人都能获得一种全新的体验。今天，我们已经是一个全球性的乐器周边设备软件先锋品牌，汇聚数以百万计来自世界各地的粉丝分享他们新创作的声学文件，他们的新的音色和他们的梦想，并与更多的人产生连结，享受生活的乐趣。</p>
        </div>
      </div>
      <div class="card">
        <img src="@/assets/about/p-1010283-copy-2@2x.png">
        <div>
          <h3>赋予音乐创造力</h3>
          <p>我们的产品范围覆盖了从免费的手机应用程序、先进的音色设计程序直到智能连接的效果单块和巡演级音箱等等众多领域。制作出让每个人都能访问的全新音色意味着与音乐制作者熟悉和喜爱的工具形成紧密的联系。我们的音乐技术与所有的主流平台兼容 – 这种连通性能让音乐创作者在任何喜欢使用的平台上探索出全新的方式来尽情表达自我。</p>
        </div>
      </div>
      <div class="card">
        <img src="@/assets/about/p-1010283-copy@2x.png">
        <div>
          <h3>音乐技术的未来</h3>
          <p>推动音乐创作技术的发展需要一个具备各种才能的团队。在 Positive Grid，音色设计师、程序员、电子工程师、工业设计师、科研人员和音乐艺术大师正在并肩工作，为的就是能站在音乐未来科技的最前沿。在 Positive Grid，我们才刚要展翅飞翔。</p>
        </div>
      </div>
    </section>
    <footer-common />
  </div>
</template>

<script>
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'

export default {
  name: 'Index',
  components: { Banner, FooterCommon },
  data () {
    return {}
  },
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>

<style scoped>
section.hero > img {
  /* max-height: 440px; */
  background-size: cover;
  width: 100%;
}
section.hero > div {
  text-align: center;
  background-image: linear-gradient(266deg, #111111, #0d0d0d);
  padding: 40px;
  line-height: 29px;
}
section.hero > div > h3 {
  margin: 0;
}

.cards {
  margin: 0 auto;
}

.card {
  display: flex;
  margin: 150px 0;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  line-height: 29px;
}
.card > img {
  flex: 1;
  max-height: 400px;
  max-width: 469px;
}
.card > div {
  max-width: 469px;
  flex: 1;
  padding-left: 50px;
  width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.card > div > h3 {
  color: white;
  font-weight: 300;
}

@media screen and (max-width: 768px) {
  .card {
    display: block;
    font-weight: 300;
    line-height: 29px;
  }
  .card > div {
    max-width: unset;
    flex: 1;
    padding: 0 10px;
    width: calc(100% - 20px);
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .card > div > h3 {
    color: white;
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue